import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { isEmpty, startCase } from "lodash";
import { Button } from "react-bootstrap";
import { toast } from "wc-toast";
import { deepComparison } from "../utils/constants";
import { apiGet, apiPost } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { useEffect } from "react";
const GameControl = () => {
  const parmas = useParams();
  let defaultData = {
    EventType: [],
    Type: [],
    Market: { cricket: [], soccer: [], tennis: [] },
  };
  const [data, setData] = useState(defaultData);
  const handelChange = (value, type, inner) => {
    setData((prev) => {
      return {
        ...prev,
        [value]:
          value !== "Market"
            ? prev[value].includes(type)
              ? prev[value].filter((res) => {
                  return res !== type;
                })
              : [...prev[value], type]
            : {
                ...prev[value],
                [inner]: prev[value][inner].includes(type)
                  ? prev[value][inner].filter((res) => {
                      return res !== type;
                    })
                  : [...prev[value][inner], type],
              },
      };
    });
  };

  const onSubmit = async () => {
    if (deepComparison(defaultData, data)) {
      toast.error("Pleae enter some input to fields");
    } else {
      const { status, data: response_users } = await apiPost(
        apiPath.gameControl,
        { userId: parmas?.id, userType: parmas?.type, result: data }
      );
      if (status === 200) {
        if (response_users.success) {
          getData();
        }
      }
    }
  };

  const getData = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.getgameControl,
      {
        userId: parmas?.id,
        userType: parmas?.type,
      }
    );
    if (status === 200) {
      if (response_users.success) {
        let result = response_users?.results;
        if (!isEmpty(result)) {
          setData({
            EventType: result?.eventTypes,
            Type: result?.marketTypes,
            Market: result?.blockedMarkets,
          });
        }
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);
  const reset = () => {
    setData(defaultData);
  };

  const navigate = useNavigate();
  return (
    <>
      <div class="wrapper">
        <div class="container-fluid container-padding-0">
          <div class="row main-box">
            <div class="">
              <div>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <h5 class="text-blue">
                    Lock Application - {startCase(parmas?.type)}
                  </h5>
                  <Button
                    className="btn btn-danger"
                    onClick={() => navigate(-1)}
                  >
                    Close
                  </Button>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <fieldset class="mt-1">
                      <legend>Event Type</legend>
                      <div class="row">
                        <div class="col-12 col-sm-12 col-md-12">
                          <ul class="game-control betgamecontrol">
                            {EventType?.map((res) => {
                              return (
                                <li>
                                  <span class="text-black font-14 me-1">
                                    {res}
                                  </span>
                                  <span class="betlock1">
                                    <label class="checkboxx">
                                      <input
                                        onChange={(e) => {
                                          handelChange("EventType", res);
                                        }}
                                        checked={data?.EventType?.includes(res)}
                                        type="checkbox"
                                      />
                                      <span class="checkmark1"></span>
                                    </label>
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <fieldset class="mt-1">
                      <legend>Type</legend>
                      <div class="row">
                        <div class="col-12 col-sm-12 col-md-12">
                          <ul class="game-control betgamecontrol">
                            {Type.map((res) => {
                              return (
                                <li>
                                  <span class="text-black font-14 me-1">
                                    {res}
                                  </span>
                                  <span class="betlock1">
                                    <label class="checkboxx">
                                      <input
                                        onChange={(e) => {
                                          handelChange("Type", res);
                                        }}
                                        checked={data?.Type?.includes(res)}
                                        type="checkbox"
                                        tabindex=""
                                      />
                                      <span class="checkmark1"></span>
                                    </label>
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <fieldset class="mt-1">
                      <legend>Market Type</legend>
                      <div class="row">
                        <div class="col-12 col-sm-12 col-md-12">
                          <div class="font-14 text-blue font-weight-bold">
                            Cricket
                          </div>
                          <ul class="game-control betgamecontrol">
                            {Cricket?.map((item) => {
                              return (
                                <li>
                                  <span class="text-black font-14 me-1">
                                    {item}
                                  </span>
                                  <span class="betlock1">
                                    <label class="checkboxx">
                                      <input
                                        onChange={(e) => {
                                          handelChange(
                                            "Market",
                                            item,
                                            "cricket"
                                          );
                                        }}
                                        checked={data?.Market[
                                          "cricket"
                                        ]?.includes(item)}
                                        type="checkbox"
                                      />
                                      <span class="checkmark1"></span>
                                    </label>
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12">
                          <div class="font-14 text-blue font-weight-bold">
                            Soccer
                          </div>
                          <ul class="game-control betgamecontrol">
                            {Soccer?.map((item) => {
                              return (
                                <li>
                                  <span class="text-black font-14 me-1">
                                    {item}
                                  </span>
                                  <span class="betlock1">
                                    <label class="checkboxx">
                                      <input
                                        onChange={(e) => {
                                          handelChange(
                                            "Market",
                                            item,
                                            "soccer"
                                          );
                                        }}
                                        checked={data?.Market[
                                          "soccer"
                                        ]?.includes(item)}
                                        type="checkbox"
                                      />
                                      <span class="checkmark1"></span>
                                    </label>
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12">
                          <div class="font-14 text-blue font-weight-bold">
                            Tennis
                          </div>
                          <ul class="game-control betgamecontrol">
                            {Tennis?.map((item) => {
                              return (
                                <li>
                                  <span class="text-black font-14 me-1">
                                    {item}
                                  </span>
                                  <span class="betlock1">
                                    <label class="checkboxx">
                                      <input
                                        onChange={(e) => {
                                          handelChange(
                                            "Market",
                                            item,
                                            "tennis"
                                          );
                                        }}
                                        checked={data?.Market[
                                          "tennis"
                                        ]?.includes(item)}
                                        type="checkbox"
                                      />
                                      <span class="checkmark1"></span>
                                    </label>
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Button className="green-btn" onClick={() => onSubmit()}>
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GameControl;

const EventType = ["Cricket", "Soccer", "Tennis","Greyhound","HorseRacing"];
const Type = [
  "All Odds",
  "Exch Bookmaker",
  "All Bookmaker",
  "Betfair Fancy",
  "Exch Fancy",
  "Other Fancy",
];

const Cricket = [
  "Match Odds",
  "Bookmaker",
  "Special Maker",
  "Tournament Winner",
  "Tied Match",
  "Completed Match",
  "To Win the Toss",
  "1st Inning Runs",
  "1st Inning 6 Ovr Line",
  "1st Inning 10 Ovr Line",
  "1st Inning 15 Ovr Line",
  "1st Inning 20 Ovr Line",
  "2nd inning Runs",
  "2nd Inning 6 Ovr Line",
  "2nd Inning 10 Ovr Line",
  "2nd Inning 15 Ovr Line",
  "Over",
  "Batsman",
  "Single Over",
  "Odd Even",
  "Three Selection",
  "Ball By Ball",
  "Lottery",
];
const Soccer = [
  "Match Odds",
  "Bookmaker",
  "Special Maker",
  "Over Under 05",
  "Over Under 15",
  "Over Under 25",
  "Over Under 35",
  "Lottery",
];
const Tennis = [
  "Match Odds",
  "Set Winner",
  "Bookmaker",
  "Special Maker",
  "Lottery",
];
